<template>
    <div class="ba b--light-gray">
        <div class="pt3 pl3">
            <div class="flex flex-wrap justify-between items-center">
                <div class="mr3 mb3 flex items-center">
                    <h6>{{title}}</h6>
                    <img @click="showInfo = true" class=" ml2 pointer" src="@/assets/img/icon_info.svg"/>
                </div>
                <Toggle class="mb3 mr3" @change="$emit('change', $event)"/>
            </div>
        </div>

        <OverlayWarning :showWarning="showInfo">
            <InfoOverlay
                :title="title"
                :description="infoDescription"
                @cancel="showInfo = false"
            />
        </OverlayWarning>
    </div>
</template>

<script>
import Toggle from '@/components/controls/Toggle.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import InfoOverlay from '@/components/global/InfoOverlay.vue';

export default {
    data() {
        return {
            showInfo: false
        };
    },
    components: {
        Toggle,
        OverlayWarning,
        InfoOverlay
    },
    props: {
        title: {
            type: String
        },
        infoDescription: {
            type: String
        }
    }
};
</script>
